$(function () {
  $("a[href*=\\#]:not([href=\\#])").click(function () {
    if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
      var $target = $(this.hash);
      $target = ($target.length && $target) || $("[name=" + this.hash.slice(1) + "]");
      if ($target.length) {
        if ($(this).parents(".menuBox").length) {
          setTimeout(function () {
            var targetOffset = $target.offset().top;
            $("html,body").animate({ scrollTop: targetOffset }, 1000);
          }, 100);
        } else {
          var targetOffset = $target.offset().top;
          $("html,body").animate({ scrollTop: targetOffset }, 1000);
        }
        return false;
      }
    }
  });

  var state = false;
  var scrollpos;
  $(".menu").on("click", function () {
    if (state == false) {
      scrollpos = $(window).scrollTop();
      $("body").addClass("fixed").css({ top: -scrollpos });
      $(".menu").addClass("on");
      $(".menuBox").stop().slideToggle(300).addClass("on");
      state = true;
    } else {
      $("body").removeClass("fixed").css({ top: 0 });
      window.scrollTo(0, scrollpos);
      $(".menu,.menuBox .menu").removeClass("on");
      $(".menuBox").stop().slideToggle(300).removeClass("on");
      state = false;
    }
  });

  $("#gHeader .downBox .giftUl .faq .ttl").click(function () {
    $(this).toggleClass("on");
    $(this).next().stop().slideToggle(300);
    return false;
  });

  $(window)
    .scroll(function () {
      if ($(window).scrollTop() > $("#gHeader").outerHeight()) {
        $("#gHeader").addClass("fix");
      } else {
        $("#gHeader").removeClass("fix");
      }
    })
    .trigger("scroll");

  $("#gHeader #gNavi li:has(ul)").hover(
    function () {
      if (!$(this).hasClass("on")) {
        $(this).addClass("on");
        $(this).find(".downBox").addClass("show");
      }
    },
    function () {
      if ($(this).hasClass("on")) {
        $(this).removeClass("on");
        $(this).find(".downBox").removeClass("show");
      }
    }
  );

  $("#gFooter .fBox .linkList > li > span,.menuBox .gift .textList li.faq span").click(function () {
    $(this).toggleClass("on");
    $(this).next().stop().slideToggle(300);
    return false;
  });

  /* Products: Swiper Gallery & DriftImage  =============== */

  const swiperGallerySF001ID = document.getElementById("swiperGallerySF001");
  const swiperGallerySFThum001ID = document.getElementById("swiperGallerySFThumbnailMobile001");
  const swiperGallerySFThumPC001ID = document.getElementById("swiperGallerySFThumbnailPC001");

  if (swiperGallerySF001ID !== null) {
    // Make Clone
    const swiperGallerySF001Clone = swiperGallerySF001ID.firstElementChild.cloneNode(true);

    const swiperGallerySF001Clone2 = swiperGallerySF001ID.firstElementChild.cloneNode(true);

    swiperGallerySFThum001ID.appendChild(swiperGallerySF001Clone);
    swiperGallerySFThumPC001ID.appendChild(swiperGallerySF001Clone2);

    // Main Gallery int -  Slide > Image
    let swiperGallerySF001ID_IMG = swiperGallerySF001ID.querySelectorAll(".swiper-slide>img");
    const swiperGallerySF001ID_IMG_Item = Array.prototype.slice.call(swiperGallerySF001ID_IMG, 0);

    swiperGallerySF001ID_IMG_Item.forEach(function (imgs) {
      // add class
      imgs.setAttribute("class", "image-zoom");
      // src copy to data-zoom
      let srcAtt = imgs.getAttribute("src");
      imgs.setAttribute("data-zoom", srcAtt);
    });

    // PC thumbnails　int -
    swiperGallerySFThumPC001ID.firstElementChild.setAttribute("class", "thumbnail-item-group");
    // PC thumbnails　int - Thumbnail - Numbering
    const swiperGallerySFThumPC001ID_Thumbnail = swiperGallerySFThumPC001ID.firstElementChild.querySelectorAll(".swiper-slide");

    swiperGallerySFThumPC001ID_Thumbnail.forEach(function (thumbs, i) {
      thumbs.setAttribute("class", "thumbnail-item");
      if (i == 0) {
        thumbs.classList.add("is--active");
      }
    });

    //Drift-zoom int

    //Swiper int - Mobile Thumbnails
    const swiperGallerySFThumbnail001 = new Swiper("#swiperGallerySFThumbnailMobile001", {
      slidesPerView: 5,
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      spaceBetween: 5,
      //  centeredSlides: true,
      breakpoints: {
        990: {
          slidesPerView: 4,
          spaceBetween: 15,
        },
      },
    });

    //Swiper int - Main Gallery

    const swiperGallerySFThumPC001ID_thumb = swiperGallerySFThumPC001ID.querySelectorAll(".thumbnail-item");

    const swiperGallerySFThumPC001ID_switchThumb = (index) => {
      swiperGallerySFThumPC001ID.querySelector(".is--active").classList.remove("is--active");
      swiperGallerySFThumPC001ID_thumb[index].classList.add("is--active");
    };

    const swiperGallerySF001 = new Swiper("#swiperGallerySF001", {
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: swiperGallerySFThumbnail001,
      },

      on: {
        afterInit: (swiper) => {
          swiperGallerySFThumPC001ID_thumb[swiper.realIndex].classList.add("is--active");
          for (let i = 0; i < swiperGallerySFThumPC001ID_thumb.length; i++) {
            swiperGallerySFThumPC001ID_thumb[i].onclick = () => {
              swiper.slideTo(i + 1);
            };
          }
        },
        slideChange: (swiper) => {
          swiperGallerySFThumPC001ID_switchThumb(swiper.realIndex);
        },
      },
    });
  }

  // Toggle
  const TGL = document.querySelectorAll(".module--toggle > .module--toggle-title");
  if (TGL !== null) {
    for (let i = 0; i < TGL.length; i++) {
      TGL[i].addEventListener("click", () => {
        let prt = TGL[i].parentNode;
        let $next = TGL[i].nextElementSibling;
        console.log(prt);
        let h = $next.firstElementChild.clientHeight;
        if (TGL[i].classList.contains("is--active")) {
          TGL[i].classList.remove("is--active");
          prt.classList.remove("is--active");
          $next.classList.remove("is--active");
          $next.style.height = h + "px";
          setTimeout(() => {
            $next.style.height = "0px";
          }, "1");
        } else {
          TGL[i].classList.add("is--active");
          prt.classList.add("is--active");
          $next.classList.add("is--active");
          $next.style.height = h + "px";
          setTimeout(() => {
            $next.style.height = "auto";
          }, "400");
        }
      });
    }
  }

  // Toggle Type2
  const TGLS = document.querySelectorAll(".module--toggle-lv2 > .module--toggle-title");
  if (TGLS !== null) {
    for (let i = 0; i < TGLS.length; i++) {
      TGLS[i].addEventListener("click", () => {
        let $next = TGLS[i].nextElementSibling;

        let h = $next.firstElementChild.clientHeight;
        if (TGLS[i].classList.contains("is--active")) {
          TGLS[i].classList.remove("is--active");
          $next.classList.remove("is--active");
          $next.style.height = h + "px";
          setTimeout(() => {
            $next.style.height = "0px";
          }, "1");
        } else {
          TGLS[i].classList.add("is--active");
          $next.classList.add("is--active");
          $next.style.height = h + "px";
        }
      });
    }
  }

  // tabbox
  const tabboxElem = document.querySelectorAll(".module--tabbox");
  if (tabboxElem !== null) {
    if (tabboxElem.length > 0) {
      for (let i = 0; i < tabboxElem.length; i++) {
        let tab = tabboxElem[i];
        let tabBtnElems = tab.querySelectorAll(".tab-item");
        let tabContentElems = tab.querySelectorAll(".tab-content");

        for (let i = 0; i < tabBtnElems.length; i++) {
          let tabBtn = tabBtnElems[i];
          let tabContent = tabContentElems[i];
          tabBtn.addEventListener("click", (e) => {
            e.preventDefault();
            for (let i = 0; i < tabBtnElems.length; i++) {
              tabBtnElems[i].classList.remove("is--active");
              tabContentElems[i].classList.remove("is--active");
            }
            tabBtn.classList.add("is--active");
            tabContent.classList.add("is--active");
          });
        }
      }
    }
  }
  // tabbox type 2
  const tabboxElem2 = document.querySelectorAll(".module--tabbox2");
  if (tabboxElem2 !== null) {
    if (tabboxElem2.length > 0) {
      for (let i = 0; i < tabboxElem2.length; i++) {
        let tab = tabboxElem2[i];
        let tabBtnElems = tab.querySelectorAll(".tab-item");
        let tabContentElems = tab.querySelectorAll(".tab-content");
        let hash = location.hash;
        window.addEventListener("load", (e) => {
          if (hash == "#0t") {
            tabBtnElems[0].classList.add("is--active");
            tabContentElems[0].classList.add("is--active");
          } else if (hash == "#1t") {
            tabBtnElems[1].classList.add("is--active");
            tabContentElems[1].classList.add("is--active");
          }
        });
        window.addEventListener("hashchange", (e) => {
          if (hash == "#0t") {
            tabBtnElems[0].classList.add("is--active");
            tabContentElems[0].classList.add("is--active");
          } else if (hash == "#1t") {
            tabBtnElems[1].classList.add("is--active");
            tabContentElems[1].classList.add("is--active");
          }
        });

        for (let i = 0; i < tabBtnElems.length; i++) {
          let tabBtn = tabBtnElems[i];
          let tabContent = tabContentElems[i];

          //     console.log(tabBtnElems[0]);

          tabBtn.addEventListener("click", (e) => {
            e.preventDefault();
            for (let i = 0; i < tabBtnElems.length; i++) {
              tabBtnElems[i].classList.remove("is--active");
              tabContentElems[i].classList.remove("is--active");
            }
            tabBtn.classList.add("is--active");
            tabContent.classList.add("is--active");
          });
        }
      }
    }
  }
  // register button on
  const customerRegisterButton = document.getElementById("customer-register-button");
  const customerRegisterButtonCheck = document.getElementById("check-customer-register-button-on");

  if ((customerRegisterButton && customerRegisterButtonCheck) !== null) {
    customerRegisterButtonCheck.addEventListener("change", (e) => {
      if (customerRegisterButtonCheck.checked) {
        customerRegisterButton.removeAttribute("disabled");
      } else {
        customerRegisterButton.setAttribute("disabled", "disabled");
      }
    });
  }
});

$(window).on("load", function () {
  var localLink = window.location + "";
  if (localLink.indexOf("#") != -1 && localLink.slice(-1) != "#") {
    localLink = localLink.slice(localLink.indexOf("#") + 1);
    $("html,body").animate({ scrollTop: $("#" + localLink).offset().top }, 500);
  }
});
